module.exports = __webpack_public_path__ + "assets/logo.c7d8416e.svg";